import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

interface StatusIconProps {
  colour: string;
  showAsStationary?: boolean;
  stroke?: string;
}

export const StatusIcon: React.FC<StatusIconProps> = ({ colour, stroke, showAsStationary }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      height={20}
      width={20}
      viewBox={'0 0 20 20'}
      fill="none"
      style={{ backgroundColor: 'transparent' }}
    >
      <circle
        cx="10"
        cy="10"
        r={showAsStationary ? '4' : '7'}
        fill={colour}
        stroke={stroke ? stroke : 'transparent'}
        strokeWidth="2"
      />
    </SvgIcon>
  );
};
